import React from 'react'
import BranchList from '../../components/branch/BranchList'

export default function BranchListPage() {
  return (
    <div>
      <BranchList/>
    </div>
  )
}
